import React, { lazy, Suspense } from 'react';

const suspenseWrapper = children => {
  return typeof window !== 'undefined' ? <Suspense fallback={ null }>{ children }</Suspense> : null;
};
const CoverImage = lazy(() => import('../products/CoverImage'));
const CartListWrapper = lazy(() => import('../cart/CartListWrapper'));
const ProductList1 = lazy(() => import('../../../layouts/shop1/ProductList'));
const ProductList2 = lazy(() => import('../../../layouts/shop2/ProductList'));
const PlaceholderProductList1 = lazy(() => import('../../../layouts/shop1/PlaceholderProductList'));
const PlaceholderProductList2 = lazy(() => import('../../../layouts/shop2/PlaceholderProductList'));
const ProductDetail = lazy(() => import('../ProductDetail'));
const Fetching = lazy(() => import('../Fetching'));
const ErrorMessage = lazy(() => import('../ErrorMessage'));
const Carousel = lazy(() => import('@wsb/guac-widget-shared/lib/components/Carousel'));
const OneColumn = lazy(() => import('../products/ProductDetailAssets/OneColumn'));
const ClassicCarousel = lazy(() => import('../products/ProductDetailAssets/Classic'));
const FeaturedCarousel = lazy(() => import('../products/ProductDetailAssets/Featured'));

export {
  CoverImage,
  CartListWrapper,
  ProductList1,
  ProductList2,
  PlaceholderProductList1,
  PlaceholderProductList2,
  ProductDetail,
  Fetching,
  ErrorMessage,
  Carousel,
  OneColumn,
  ClassicCarousel,
  FeaturedCarousel,
  suspenseWrapper
};
